var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.getLoadingStatus)?_c('div',{attrs:{"id":"loading"}},[_c('img',{staticClass:"loading-img",attrs:{"src":require("../src/assets/images/loadingInfo.png"),"alt":""}})]):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }